import React from 'react';
import styled from 'styled-components';
import { SOFT_TOMATO } from '../../colors';

interface SearchBarProps {
  placeholder: string;
  onSearch: (value: string) => void;
  style?: any;
}

const SearchBar = ({
  placeholder,
  onSearch,
  style
}: SearchBarProps) => {
  return (
    <SearchWrapper style={style}>
      <SearchInput 
        type="text" 
        placeholder={placeholder} 
        onChange={(e) => onSearch(e.target.value)}
      />
      <SearchButton>{'Search'.toUpperCase()}</SearchButton>
    </SearchWrapper>
  );
};

export default SearchBar;

// --- STYLES ---

const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 500px;
  border: 1px solid #ccc;
  border-radius: 999px;
  overflow: hidden;
  background-color: #fff;

  @media (max-width: 480px) {
    max-width: 100%;
  }
`;

const SearchInput = styled.input`
  flex: 1;
  min-width: 0;
  padding: 0.75rem 1rem;
  border: none;
  font-family: 'Poppins-Medium';
  font-size: 0.8rem;
  outline: none;
`;

const SearchButton = styled.button`
  flex-shrink: 0;
  padding: 0.75rem 1.25rem;
  background-color: ${SOFT_TOMATO};
  color: white;
  border: none;
  cursor: pointer;
  font-family: 'Poppins-SemiBold';
  font-size: 0.8rem;
  white-space: nowrap;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: ${SOFT_TOMATO};
  }
`;
